import { ButtonLink, EllipsisVerticalIcon, PlusIcon } from '@fukuri-admins/ui/common';
import { IconButton, Menu, MenuItem } from '@mui/material';
import { TableRoot } from '../../../../components/common/Table/TableBase/TableRoot';
import { ActionTableSortParamsType } from '../../../../types/table/ActionTableSortParamsType';
import { handleSorting } from '../../../../utils/sortings';
import { GROUP_TABLE_COLUMNS } from '../../constants';
import { GroupRow } from '../../types';
import styles from './styles.module.scss';

type Props = {
  groups: GroupRow[];
  setGroups: React.Dispatch<React.SetStateAction<GroupRow[]>>;
  createLink: string;
  sortParams: ActionTableSortParamsType;
  menuAnchorEl: HTMLElement | null;
  setSortParams: React.Dispatch<React.SetStateAction<ActionTableSortParamsType>>;
  onClickRow: (groupId: number) => void;
  onClickMenu: (event: React.MouseEvent<HTMLButtonElement>, groupId: number) => void;
  onCloseMenu: () => void;
  onClickEdit: () => void;
  onClickDelete: () => void;
};

/**
 * @param groups - グループ一覧
 * @param setGroups - グループ一覧を更新する関数
 * @param sortParams - ソートパラメータ
 * @param menuAnchorEl - メニューのアンカー要素
 * @param setSortParams - ソートパラメータを更新する関数
 * @param onClickMenu - メニュークリック処理
 * @param onCloseMenu - メニュークローズ処理
 * @param onClickEdit - 編集クリック処理
 * @param onClickDelete - 削除クリック処理
 */
export const GroupList: React.FC<Props> = ({
  groups,
  setGroups,
  createLink,
  sortParams,
  menuAnchorEl,
  setSortParams,
  onClickRow,
  onClickMenu,
  onCloseMenu,
  onClickEdit,
  onClickDelete,
}) => {
  const tableRows = groups.map((group, index) => (
    <tr
      key={group.id}
      className={styles.tableRow}
      data-testid={`table-row-${index}`}
      onClick={() => onClickRow(group.id)}
    >
      <td className={styles.tableCell}>{group.name}</td>
      <td className={styles.tableCell}>{group.code}</td>
      <td className={styles.tableCell}>
        <div className={styles.descriptionContent}>{group.description}</div>
      </td>
      <td className={styles.tableCell}>{group.createdAt}</td>
      <td className={styles.tableCell}>{group.updatedAt}</td>
      <td className={styles.tableCellAction}>
        <IconButton
          onClick={e => {
            e.stopPropagation();
            onClickMenu(e, group.id);
          }}
          className={styles.iconButton}
          size='small'
        >
          <EllipsisVerticalIcon />
        </IconButton>
      </td>
    </tr>
  ));

  return (
    <div className={styles.wrapper}>
      <div className={styles.container}>
        <div className={styles.buttonContainer}>
          <ButtonLink
            to={createLink}
            icon={<PlusIcon size='xs' />}
            iconPosition='left'
            variant='primary'
            size='md'
          >
            新規作成
          </ButtonLink>
        </div>
        <TableRoot
          columns={GROUP_TABLE_COLUMNS}
          rows={tableRows}
          sortParams={sortParams}
          onClickHeader={column =>
            handleSorting(column, sortParams, groups, setSortParams, setGroups)
          }
        />
        <Menu
          anchorEl={menuAnchorEl}
          open={Boolean(menuAnchorEl)}
          onClose={onCloseMenu}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'right',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
        >
          <MenuItem onClick={onClickEdit} className={styles.menuItem}>
            編集
          </MenuItem>
          <MenuItem onClick={onClickDelete} className={styles.menuItemDelete}>
            削除
          </MenuItem>
        </Menu>
      </div>
    </div>
  );
};
